import { render, staticRenderFns } from "./titleScreen.vue?vue&type=template&id=618fea40&scoped=true"
import script from "./titleScreen.vue?vue&type=script&lang=js"
export * from "./titleScreen.vue?vue&type=script&lang=js"
import style0 from "./titleScreen.vue?vue&type=style&index=0&id=618fea40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618fea40",
  null
  
)

export default component.exports